import { render, staticRenderFns } from "./refundComponent.vue?vue&type=template&id=b999c6f6&scoped=true"
import script from "./refundComponent.vue?vue&type=script&lang=js"
export * from "./refundComponent.vue?vue&type=script&lang=js"
import style0 from "./refundComponent.vue?vue&type=style&index=0&id=b999c6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b999c6f6",
  null
  
)

export default component.exports